import { FormControl } from '@angular/forms';

export function containsSpecialCharactersValidator(formControl: FormControl) {
  const CONTAINS_SPECIAL_CHARACTERS_REGEX = /[&*^()<>\s]/;

  return !CONTAINS_SPECIAL_CHARACTERS_REGEX.test(formControl.value) ? null : {
    containsSpecialCharacters: {
      valid: false
    }
  }
}
